import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createEIP1193Provider } from '@web3-onboard/common';
import { InjectedNameSpace, ProviderIdentityFlag, ProviderLabel } from './types.js';
var UNSUPPORTED_METHOD = null;
function getInjectedInterface(identity, checkOtherProviderFlags) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {
            provider: window.ethereum.providers && Array.isArray(window.ethereum.providers) ? getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) : window.ethereum
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function getInterfaceFromProvidersArray(identity, checkOtherProviderFlags) {
  return window.ethereum.providers.find(function (provider) {
    return checkOtherProviderFlags ? !!provider[identity] && !otherProviderFlagsExist(identity, provider) : !!provider[identity];
  });
}
function otherProviderFlagsExist(identity, provider) {
  var otherProviderFlags = Object.values(ProviderIdentityFlag).filter(function (id) {
    return id !== identity && id !== ProviderIdentityFlag.Detected;
  });
  return otherProviderFlags.some(function (id) {
    return !!provider[id];
  });
}
var metamask = {
  label: ProviderLabel.MetaMask,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref2) {
    var provider = _ref2.provider;
    return !!provider && !!provider[ProviderIdentityFlag.MetaMask] && !otherProviderFlagsExist(ProviderIdentityFlag.MetaMask, provider);
  },
  getIcon: function () {
    var _getIcon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return import('./icons/metamask.js');
          case 2:
            return _context2.abrupt("return", _context2.sent.default);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function getIcon() {
      return _getIcon.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.MetaMask, true),
  platforms: ['all']
};
var infinitywallet = {
  label: ProviderLabel.InfinityWallet,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref3) {
    var provider = _ref3.provider;
    return !!provider && !!provider[ProviderIdentityFlag.InfinityWallet];
  },
  getIcon: function () {
    var _getIcon2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return import('./icons/infinitywallet.js');
          case 2:
            return _context3.abrupt("return", _context3.sent.default);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function getIcon() {
      return _getIcon2.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.InfinityWallet),
  platforms: ['desktop']
};
var exodus = {
  label: ProviderLabel.Exodus,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref4) {
    var provider = _ref4.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Exodus];
  },
  getIcon: function () {
    var _getIcon3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return import('./icons/exodus.js');
          case 2:
            return _context4.abrupt("return", _context4.sent.default);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function getIcon() {
      return _getIcon3.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.Exodus),
  platforms: ['all']
};
var frontier = {
  label: ProviderLabel.Frontier,
  injectedNamespace: InjectedNameSpace.Frontier,
  checkProviderIdentity: function checkProviderIdentity(_ref5) {
    var provider = _ref5.provider;
    return !!provider && !!provider['ethereum'] && !!provider['ethereum'][ProviderIdentityFlag.Frontier];
  },
  getIcon: function () {
    var _getIcon4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return import('./icons/frontier.js');
          case 2:
            return _context5.abrupt("return", _context5.sent.default);
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function getIcon() {
      return _getIcon4.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", {
              provider: createEIP1193Provider(window.frontier.ethereum)
            });
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function getInterface() {
      return _getInterface.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var brave = {
  label: ProviderLabel.Brave,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref6) {
    var provider = _ref6.provider;
    return !!provider && !!provider[ProviderIdentityFlag.BraveWallet];
  },
  getIcon: function () {
    var _getIcon5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return import('./icons/brave.js');
          case 2:
            return _context7.abrupt("return", _context7.sent.default);
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    function getIcon() {
      return _getIcon5.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.BraveWallet),
  platforms: ['all']
};
var binance = {
  label: ProviderLabel.Binance,
  injectedNamespace: InjectedNameSpace.Binance,
  checkProviderIdentity: function checkProviderIdentity(_ref7) {
    var provider = _ref7.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Binance];
  },
  getIcon: function () {
    var _getIcon6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return import('./icons/binance.js');
          case 2:
            return _context8.abrupt("return", _context8.sent.default);
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    function getIcon() {
      return _getIcon6.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var tempBNBProvider, addListener, provider;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            // Replace the provider as the BNB provider is readonly
            tempBNBProvider = _objectSpread({}, window.BinanceChain);
            window.BinanceChain = tempBNBProvider;
            addListener = window.BinanceChain.on.bind(window.BinanceChain);
            window.BinanceChain.on = function (event, func) {
              // intercept chainChanged event and format string
              if (event === 'chainChanged') {
                addListener(event, function (chainId) {
                  var cb = func;
                  cb("0x".concat(parseInt(chainId).toString(16)));
                });
              } else {
                addListener(event, func);
              }
            };
            provider = createEIP1193Provider(window.BinanceChain, {
              eth_chainId: function eth_chainId(_ref8) {
                var baseRequest = _ref8.baseRequest;
                return baseRequest({
                  method: 'eth_chainId'
                }).then(function (id) {
                  return "0x".concat(parseInt(id).toString(16));
                });
              },
              // Unsupported method -- will throw error
              eth_selectAccounts: UNSUPPORTED_METHOD,
              wallet_switchEthereumChain: UNSUPPORTED_METHOD
            });
            provider.removeListener = function (event, func) {};
            return _context9.abrupt("return", {
              provider: provider
            });
          case 7:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    function getInterface() {
      return _getInterface2.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var coinbase = {
  label: ProviderLabel.Coinbase,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref9) {
    var provider = _ref9.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Coinbase] || !!provider && !!provider[ProviderIdentityFlag.CoinbaseExtension];
  },
  getIcon: function () {
    var _getIcon7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return import('./icons/coinbase.js');
          case 2:
            return _context10.abrupt("return", _context10.sent.default);
          case 3:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    function getIcon() {
      return _getIcon7.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var _yield$getInjectedInt, provider, addListener;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return getInjectedInterface(ProviderIdentityFlag.CoinbaseExtension)();
          case 2:
            _yield$getInjectedInt = _context11.sent;
            provider = _yield$getInjectedInt.provider;
            addListener = provider.on.bind(provider);
            provider.on = function (event, func) {
              // intercept chainChanged event and format string
              if (event === 'chainChanged') {
                addListener(event, function (chainId) {
                  var cb = func;
                  cb("0x".concat(parseInt(chainId).toString(16)));
                });
              } else {
                addListener(event, func);
              }
            };
            return _context11.abrupt("return", {
              provider: provider
            });
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    function getInterface() {
      return _getInterface3.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var detected = {
  label: ProviderLabel.Detected,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref10) {
    var provider = _ref10.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Detected];
  },
  getIcon: function () {
    var _getIcon8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return import('./icons/detected.js');
          case 2:
            return _context12.abrupt("return", _context12.sent.default);
          case 3:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    function getIcon() {
      return _getIcon8.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", {
              provider: window.ethereum
            });
          case 1:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    function getInterface() {
      return _getInterface4.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var trust = {
  label: ProviderLabel.Trust,
  injectedNamespace: InjectedNameSpace.Trust,
  checkProviderIdentity: function checkProviderIdentity(_ref11) {
    var provider = _ref11.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Trust];
  },
  getIcon: function () {
    var _getIcon9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return import('./icons/trust.js');
          case 2:
            return _context14.abrupt("return", _context14.sent.default);
          case 3:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    function getIcon() {
      return _getIcon9.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      var ethereumInjectionExists, provider;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            ethereumInjectionExists = window.hasOwnProperty(InjectedNameSpace.Ethereum);
            // check if trust is injected into window.ethereum
            if (ethereumInjectionExists && window[InjectedNameSpace.Ethereum].isTrust) {
              provider = window[InjectedNameSpace.Ethereum];
            } else {
              // directly use the window.trustwallet injection
              provider = window[InjectedNameSpace.Trust];
            }
            return _context15.abrupt("return", {
              provider: provider
            });
          case 3:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    function getInterface() {
      return _getInterface5.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var opera = {
  label: ProviderLabel.Opera,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref12) {
    var provider = _ref12.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Opera];
  },
  getIcon: function () {
    var _getIcon10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return import('./icons/opera.js');
          case 2:
            return _context16.abrupt("return", _context16.sent.default);
          case 3:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    function getIcon() {
      return _getIcon10.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum, {
                eth_requestAccounts: function () {
                  var _eth_requestAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(_ref13) {
                    var baseRequest;
                    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                      while (1) switch (_context17.prev = _context17.next) {
                        case 0:
                          baseRequest = _ref13.baseRequest;
                          return _context17.abrupt("return", baseRequest({
                            method: 'eth_accounts'
                          }));
                        case 2:
                        case "end":
                          return _context17.stop();
                      }
                    }, _callee17);
                  }));
                  function eth_requestAccounts(_x) {
                    return _eth_requestAccounts.apply(this, arguments);
                  }
                  return eth_requestAccounts;
                }(),
                eth_selectAccounts: UNSUPPORTED_METHOD
              })
            });
          case 1:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    function getInterface() {
      return _getInterface6.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var status = {
  label: ProviderLabel.Status,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref14) {
    var provider = _ref14.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Status];
  },
  getIcon: function () {
    var _getIcon11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return import('./icons/status.js');
          case 2:
            return _context19.abrupt("return", _context19.sent.default);
          case 3:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    function getIcon() {
      return _getIcon11.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
      var provider;
      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            provider = window.ethereum;
            return _context20.abrupt("return", {
              provider: provider
            });
          case 2:
          case "end":
            return _context20.stop();
        }
      }, _callee20);
    }));
    function getInterface() {
      return _getInterface7.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var alphawallet = {
  label: ProviderLabel.AlphaWallet,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref15) {
    var provider = _ref15.provider;
    return !!provider && !!provider[ProviderIdentityFlag.AlphaWallet];
  },
  getIcon: function () {
    var _getIcon12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
      return _regeneratorRuntime().wrap(function _callee21$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return import('./icons/alphawallet.js');
          case 2:
            return _context21.abrupt("return", _context21.sent.default);
          case 3:
          case "end":
            return _context21.stop();
        }
      }, _callee21);
    }));
    function getIcon() {
      return _getIcon12.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum, {
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
              })
            });
          case 1:
          case "end":
            return _context22.stop();
        }
      }, _callee22);
    }));
    function getInterface() {
      return _getInterface8.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var apexwallet = {
  label: ProviderLabel.ApexWallet,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref16) {
    var provider = _ref16.provider;
    return !!provider && !!provider[ProviderIdentityFlag.ApexWallet];
  },
  getIcon: function () {
    var _getIcon13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
      return _regeneratorRuntime().wrap(function _callee23$(_context23) {
        while (1) switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return import('./icons/apexwallet.js');
          case 2:
            return _context23.abrupt("return", _context23.sent.default);
          case 3:
          case "end":
            return _context23.stop();
        }
      }, _callee23);
    }));
    function getIcon() {
      return _getIcon13.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
      return _regeneratorRuntime().wrap(function _callee24$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt("return", {
              provider: window.ethereum
            });
          case 1:
          case "end":
            return _context24.stop();
        }
      }, _callee24);
    }));
    function getInterface() {
      return _getInterface9.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop', 'Chrome', 'Chromium', 'Microsoft Edge']
};
var atoken = {
  label: ProviderLabel.AToken,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref17) {
    var provider = _ref17.provider;
    return !!provider && !!provider[ProviderIdentityFlag.AToken];
  },
  getIcon: function () {
    var _getIcon14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      return _regeneratorRuntime().wrap(function _callee25$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            _context25.next = 2;
            return import('./icons/atoken.js');
          case 2:
            return _context25.abrupt("return", _context25.sent.default);
          case 3:
          case "end":
            return _context25.stop();
        }
      }, _callee25);
    }));
    function getIcon() {
      return _getIcon14.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
      return _regeneratorRuntime().wrap(function _callee26$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            return _context26.abrupt("return", {
              provider: window.ethereum
            });
          case 1:
          case "end":
            return _context26.stop();
        }
      }, _callee26);
    }));
    function getInterface() {
      return _getInterface10.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var bifrostwallet = {
  label: ProviderLabel.BifrostWallet,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref18) {
    var provider = _ref18.provider;
    return !!provider && !!provider[ProviderIdentityFlag.BifrostWallet];
  },
  getIcon: function () {
    var _getIcon15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
      return _regeneratorRuntime().wrap(function _callee27$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            _context27.next = 2;
            return import('./icons/bifrostwallet.js');
          case 2:
            return _context27.abrupt("return", _context27.sent.default);
          case 3:
          case "end":
            return _context27.stop();
        }
      }, _callee27);
    }));
    function getIcon() {
      return _getIcon15.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.BifrostWallet),
  platforms: ['all']
};
var bitpie = {
  label: ProviderLabel.Bitpie,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity() {
    return !!window.Bitpie;
  },
  getIcon: function () {
    var _getIcon16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
      return _regeneratorRuntime().wrap(function _callee28$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            _context28.next = 2;
            return import('./icons/bitpie.js');
          case 2:
            return _context28.abrupt("return", _context28.sent.default);
          case 3:
          case "end":
            return _context28.stop();
        }
      }, _callee28);
    }));
    function getIcon() {
      return _getIcon16.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
      return _regeneratorRuntime().wrap(function _callee29$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            return _context29.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum, {
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
              })
            });
          case 1:
          case "end":
            return _context29.stop();
        }
      }, _callee29);
    }));
    function getInterface() {
      return _getInterface11.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var blockwallet = {
  label: ProviderLabel.BlockWallet,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref19) {
    var provider = _ref19.provider;
    return !!provider && !!provider[ProviderIdentityFlag.BlockWallet];
  },
  getIcon: function () {
    var _getIcon17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
      return _regeneratorRuntime().wrap(function _callee30$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return import('./icons/blockwallet.js');
          case 2:
            return _context30.abrupt("return", _context30.sent.default);
          case 3:
          case "end":
            return _context30.stop();
        }
      }, _callee30);
    }));
    function getIcon() {
      return _getIcon17.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.BlockWallet),
  platforms: ['desktop']
};
var frame = {
  label: ProviderLabel.Frame,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref20) {
    var provider = _ref20.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Frame];
  },
  getIcon: function () {
    var _getIcon18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
      return _regeneratorRuntime().wrap(function _callee31$(_context31) {
        while (1) switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return import('./icons/frame.js');
          case 2:
            return _context31.abrupt("return", _context31.sent.default);
          case 3:
          case "end":
            return _context31.stop();
        }
      }, _callee31);
    }));
    function getIcon() {
      return _getIcon18.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
      return _regeneratorRuntime().wrap(function _callee32$(_context32) {
        while (1) switch (_context32.prev = _context32.next) {
          case 0:
            return _context32.abrupt("return", {
              provider: window.ethereum
            });
          case 1:
          case "end":
            return _context32.stop();
        }
      }, _callee32);
    }));
    function getInterface() {
      return _getInterface12.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var huobiwallet = {
  label: ProviderLabel.HuobiWallet,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref21) {
    var provider = _ref21.provider;
    return !!provider && !!provider[ProviderIdentityFlag.HuobiWallet];
  },
  getIcon: function () {
    var _getIcon19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
      return _regeneratorRuntime().wrap(function _callee33$(_context33) {
        while (1) switch (_context33.prev = _context33.next) {
          case 0:
            _context33.next = 2;
            return import('./icons/huobiwallet.js');
          case 2:
            return _context33.abrupt("return", _context33.sent.default);
          case 3:
          case "end":
            return _context33.stop();
        }
      }, _callee33);
    }));
    function getIcon() {
      return _getIcon19.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
      return _regeneratorRuntime().wrap(function _callee34$(_context34) {
        while (1) switch (_context34.prev = _context34.next) {
          case 0:
            return _context34.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum, {
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
              })
            });
          case 1:
          case "end":
            return _context34.stop();
        }
      }, _callee34);
    }));
    function getInterface() {
      return _getInterface13.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var hyperpay = {
  label: ProviderLabel.HyperPay,
  injectedNamespace: InjectedNameSpace.Ethereum,
  // Note: The property `hiWallet` is as of now the only known way of identifying hyperpay
  // wallet as it is a direct clone of metamask. `checkProviderIdentity` implementation is subject to
  // future changes
  checkProviderIdentity: function checkProviderIdentity() {
    return !!window.hiWallet;
  },
  getIcon: function () {
    var _getIcon20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
      return _regeneratorRuntime().wrap(function _callee35$(_context35) {
        while (1) switch (_context35.prev = _context35.next) {
          case 0:
            _context35.next = 2;
            return import('./icons/hyperpay.js');
          case 2:
            return _context35.abrupt("return", _context35.sent.default);
          case 3:
          case "end":
            return _context35.stop();
        }
      }, _callee35);
    }));
    function getIcon() {
      return _getIcon20.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
      return _regeneratorRuntime().wrap(function _callee36$(_context36) {
        while (1) switch (_context36.prev = _context36.next) {
          case 0:
            return _context36.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum, {
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
              })
            });
          case 1:
          case "end":
            return _context36.stop();
        }
      }, _callee36);
    }));
    function getInterface() {
      return _getInterface14.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var imtoken = {
  label: ProviderLabel.ImToken,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref22) {
    var provider = _ref22.provider;
    return !!provider && !!provider[ProviderIdentityFlag.ImToken];
  },
  getIcon: function () {
    var _getIcon21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
      return _regeneratorRuntime().wrap(function _callee37$(_context37) {
        while (1) switch (_context37.prev = _context37.next) {
          case 0:
            _context37.next = 2;
            return import('./icons/imtoken.js');
          case 2:
            return _context37.abrupt("return", _context37.sent.default);
          case 3:
          case "end":
            return _context37.stop();
        }
      }, _callee37);
    }));
    function getIcon() {
      return _getIcon21.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
      return _regeneratorRuntime().wrap(function _callee38$(_context38) {
        while (1) switch (_context38.prev = _context38.next) {
          case 0:
            return _context38.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum, {
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
              })
            });
          case 1:
          case "end":
            return _context38.stop();
        }
      }, _callee38);
    }));
    function getInterface() {
      return _getInterface15.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var liquality = {
  label: ProviderLabel.Liquality,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref23) {
    var provider = _ref23.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Liquality];
  },
  getIcon: function () {
    var _getIcon22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
      return _regeneratorRuntime().wrap(function _callee39$(_context39) {
        while (1) switch (_context39.prev = _context39.next) {
          case 0:
            _context39.next = 2;
            return import('./icons/liquality.js');
          case 2:
            return _context39.abrupt("return", _context39.sent.default);
          case 3:
          case "end":
            return _context39.stop();
        }
      }, _callee39);
    }));
    function getIcon() {
      return _getIcon22.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
      var provider;
      return _regeneratorRuntime().wrap(function _callee40$(_context40) {
        while (1) switch (_context40.prev = _context40.next) {
          case 0:
            provider = createEIP1193Provider(window.ethereum, {
              wallet_switchEthereumChain: UNSUPPORTED_METHOD,
              eth_selectAccounts: UNSUPPORTED_METHOD
            });
            provider.removeListener = function (event, func) {};
            return _context40.abrupt("return", {
              provider: provider
            });
          case 3:
          case "end":
            return _context40.stop();
        }
      }, _callee40);
    }));
    function getInterface() {
      return _getInterface16.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var meetone = {
  label: ProviderLabel.MeetOne,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref24) {
    var provider = _ref24.provider;
    return !!provider && provider[ProviderIdentityFlag.MeetOne] === 'MEETONE';
  },
  getIcon: function () {
    var _getIcon23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
      return _regeneratorRuntime().wrap(function _callee41$(_context41) {
        while (1) switch (_context41.prev = _context41.next) {
          case 0:
            _context41.next = 2;
            return import('./icons/meetone.js');
          case 2:
            return _context41.abrupt("return", _context41.sent.default);
          case 3:
          case "end":
            return _context41.stop();
        }
      }, _callee41);
    }));
    function getIcon() {
      return _getIcon23.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
      return _regeneratorRuntime().wrap(function _callee42$(_context42) {
        while (1) switch (_context42.prev = _context42.next) {
          case 0:
            return _context42.abrupt("return", {
              provider: window.ethereum
            });
          case 1:
          case "end":
            return _context42.stop();
        }
      }, _callee42);
    }));
    function getInterface() {
      return _getInterface17.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var mykey = {
  label: ProviderLabel.MyKey,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref25) {
    var provider = _ref25.provider;
    return !!provider && !!provider[ProviderIdentityFlag.MyKey];
  },
  getIcon: function () {
    var _getIcon24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
      return _regeneratorRuntime().wrap(function _callee43$(_context43) {
        while (1) switch (_context43.prev = _context43.next) {
          case 0:
            _context43.next = 2;
            return import('./icons/mykey.js');
          case 2:
            return _context43.abrupt("return", _context43.sent.default);
          case 3:
          case "end":
            return _context43.stop();
        }
      }, _callee43);
    }));
    function getIcon() {
      return _getIcon24.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
      return _regeneratorRuntime().wrap(function _callee44$(_context44) {
        while (1) switch (_context44.prev = _context44.next) {
          case 0:
            return _context44.abrupt("return", {
              provider: window.ethereum
            });
          case 1:
          case "end":
            return _context44.stop();
        }
      }, _callee44);
    }));
    function getInterface() {
      return _getInterface18.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var ownbit = {
  label: ProviderLabel.OwnBit,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref26) {
    var provider = _ref26.provider;
    return !!provider && !!provider[ProviderIdentityFlag.OwnBit];
  },
  getIcon: function () {
    var _getIcon25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
      return _regeneratorRuntime().wrap(function _callee45$(_context45) {
        while (1) switch (_context45.prev = _context45.next) {
          case 0:
            _context45.next = 2;
            return import('./icons/ownbit.js');
          case 2:
            return _context45.abrupt("return", _context45.sent.default);
          case 3:
          case "end":
            return _context45.stop();
        }
      }, _callee45);
    }));
    function getIcon() {
      return _getIcon25.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
      var provider;
      return _regeneratorRuntime().wrap(function _callee46$(_context46) {
        while (1) switch (_context46.prev = _context46.next) {
          case 0:
            provider = createEIP1193Provider(window.ethereum, {
              eth_chainId: function eth_chainId(_ref27) {
                var baseRequest = _ref27.baseRequest;
                return baseRequest({
                  method: 'eth_chainId'
                }).then(function (id) {
                  return "0x".concat(parseInt(id).toString(16));
                });
              },
              wallet_switchEthereumChain: UNSUPPORTED_METHOD,
              eth_selectAccounts: UNSUPPORTED_METHOD
            });
            provider.removeListener = function (event, listener) {};
            provider.on = function (event, listener) {};
            return _context46.abrupt("return", {
              provider: provider
            });
          case 4:
          case "end":
            return _context46.stop();
        }
      }, _callee46);
    }));
    function getInterface() {
      return _getInterface19.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var tokenpocket = {
  label: ProviderLabel.TokenPocket,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref28) {
    var provider = _ref28.provider;
    return !!provider && !!provider[ProviderIdentityFlag.TokenPocket] && !provider[ProviderIdentityFlag.TP];
  },
  getIcon: function () {
    var _getIcon26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
      return _regeneratorRuntime().wrap(function _callee47$(_context47) {
        while (1) switch (_context47.prev = _context47.next) {
          case 0:
            _context47.next = 2;
            return import('./icons/tokenpocket.js');
          case 2:
            return _context47.abrupt("return", _context47.sent.default);
          case 3:
          case "end":
            return _context47.stop();
        }
      }, _callee47);
    }));
    function getIcon() {
      return _getIcon26.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.TokenPocket),
  platforms: ['all']
};
var tp = {
  label: ProviderLabel.TP,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref29) {
    var provider = _ref29.provider;
    return !!provider && !!provider[ProviderIdentityFlag.TP];
  },
  getIcon: function () {
    var _getIcon27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
      return _regeneratorRuntime().wrap(function _callee48$(_context48) {
        while (1) switch (_context48.prev = _context48.next) {
          case 0:
            _context48.next = 2;
            return import('./icons/tp.js');
          case 2:
            return _context48.abrupt("return", _context48.sent.default);
          case 3:
          case "end":
            return _context48.stop();
        }
      }, _callee48);
    }));
    function getIcon() {
      return _getIcon27.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
      return _regeneratorRuntime().wrap(function _callee49$(_context49) {
        while (1) switch (_context49.prev = _context49.next) {
          case 0:
            return _context49.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum, {
                wallet_switchEthereumChain: UNSUPPORTED_METHOD,
                eth_selectAccounts: UNSUPPORTED_METHOD
              })
            });
          case 1:
          case "end":
            return _context49.stop();
        }
      }, _callee49);
    }));
    function getInterface() {
      return _getInterface20.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var xdefi = {
  label: ProviderLabel.XDEFI,
  injectedNamespace: InjectedNameSpace.XFI,
  checkProviderIdentity: function checkProviderIdentity(_ref30) {
    var provider = _ref30.provider;
    return provider && provider.ethereum && provider.ethereum[ProviderIdentityFlag.XDEFI];
  },
  getIcon: function () {
    var _getIcon28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
      return _regeneratorRuntime().wrap(function _callee50$(_context50) {
        while (1) switch (_context50.prev = _context50.next) {
          case 0:
            _context50.next = 2;
            return import('./icons/xdefi.js');
          case 2:
            return _context50.abrupt("return", _context50.sent.default);
          case 3:
          case "end":
            return _context50.stop();
        }
      }, _callee50);
    }));
    function getIcon() {
      return _getIcon28.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
      return _regeneratorRuntime().wrap(function _callee51$(_context51) {
        while (1) switch (_context51.prev = _context51.next) {
          case 0:
            return _context51.abrupt("return", {
              provider: window.xfi && window.xfi.ethereum
            });
          case 1:
          case "end":
            return _context51.stop();
        }
      }, _callee51);
    }));
    function getInterface() {
      return _getInterface21.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var oneInch = {
  label: ProviderLabel.OneInch,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref31) {
    var provider = _ref31.provider;
    return !!provider && !!provider[ProviderIdentityFlag.OneInch];
  },
  getIcon: function () {
    var _getIcon29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
      return _regeneratorRuntime().wrap(function _callee52$(_context52) {
        while (1) switch (_context52.prev = _context52.next) {
          case 0:
            _context52.next = 2;
            return import('./icons/oneInch.js');
          case 2:
            return _context52.abrupt("return", _context52.sent.default);
          case 3:
          case "end":
            return _context52.stop();
        }
      }, _callee52);
    }));
    function getIcon() {
      return _getIcon29.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
      return _regeneratorRuntime().wrap(function _callee53$(_context53) {
        while (1) switch (_context53.prev = _context53.next) {
          case 0:
            return _context53.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum)
            });
          case 1:
          case "end":
            return _context53.stop();
        }
      }, _callee53);
    }));
    function getInterface() {
      return _getInterface22.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['mobile']
};
var tokenary = {
  label: ProviderLabel.Tokenary,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref32) {
    var provider = _ref32.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Tokenary];
  },
  getIcon: function () {
    var _getIcon30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
      return _regeneratorRuntime().wrap(function _callee54$(_context54) {
        while (1) switch (_context54.prev = _context54.next) {
          case 0:
            _context54.next = 2;
            return import('./icons/tokenary.js');
          case 2:
            return _context54.abrupt("return", _context54.sent.default);
          case 3:
          case "end":
            return _context54.stop();
        }
      }, _callee54);
    }));
    function getIcon() {
      return _getIcon30.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
      return _regeneratorRuntime().wrap(function _callee55$(_context55) {
        while (1) switch (_context55.prev = _context55.next) {
          case 0:
            return _context55.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum)
            });
          case 1:
          case "end":
            return _context55.stop();
        }
      }, _callee55);
    }));
    function getInterface() {
      return _getInterface23.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var tally = {
  label: ProviderLabel.Tally,
  injectedNamespace: InjectedNameSpace.Tally,
  checkProviderIdentity: function checkProviderIdentity(_ref33) {
    var provider = _ref33.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Tally];
  },
  getIcon: function () {
    var _getIcon31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
      return _regeneratorRuntime().wrap(function _callee56$(_context56) {
        while (1) switch (_context56.prev = _context56.next) {
          case 0:
            _context56.next = 2;
            return import('./icons/tallywallet.js');
          case 2:
            return _context56.abrupt("return", _context56.sent.default);
          case 3:
          case "end":
            return _context56.stop();
        }
      }, _callee56);
    }));
    function getIcon() {
      return _getIcon31.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
      return _regeneratorRuntime().wrap(function _callee57$(_context57) {
        while (1) switch (_context57.prev = _context57.next) {
          case 0:
            return _context57.abrupt("return", {
              provider: createEIP1193Provider(window.tally)
            });
          case 1:
          case "end":
            return _context57.stop();
        }
      }, _callee57);
    }));
    function getInterface() {
      return _getInterface24.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var zeal = {
  label: ProviderLabel.Zeal,
  injectedNamespace: InjectedNameSpace.Zeal,
  checkProviderIdentity: function checkProviderIdentity(_ref34) {
    var provider = _ref34.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Zeal];
  },
  getIcon: function () {
    var _getIcon32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
      return _regeneratorRuntime().wrap(function _callee58$(_context58) {
        while (1) switch (_context58.prev = _context58.next) {
          case 0:
            _context58.next = 2;
            return import('./icons/zeal.js');
          case 2:
            return _context58.abrupt("return", _context58.sent.default);
          case 3:
          case "end":
            return _context58.stop();
        }
      }, _callee58);
    }));
    function getIcon() {
      return _getIcon32.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
      return _regeneratorRuntime().wrap(function _callee59$(_context59) {
        while (1) switch (_context59.prev = _context59.next) {
          case 0:
            return _context59.abrupt("return", {
              provider: createEIP1193Provider(window.zeal)
            });
          case 1:
          case "end":
            return _context59.stop();
        }
      }, _callee59);
    }));
    function getInterface() {
      return _getInterface25.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var rabby = {
  label: ProviderLabel.Rabby,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref35) {
    var provider = _ref35.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Rabby];
  },
  getIcon: function () {
    var _getIcon33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
      return _regeneratorRuntime().wrap(function _callee60$(_context60) {
        while (1) switch (_context60.prev = _context60.next) {
          case 0:
            _context60.next = 2;
            return import('./icons/rabby.js');
          case 2:
            return _context60.abrupt("return", _context60.sent.default);
          case 3:
          case "end":
            return _context60.stop();
        }
      }, _callee60);
    }));
    function getIcon() {
      return _getIcon33.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
      return _regeneratorRuntime().wrap(function _callee61$(_context61) {
        while (1) switch (_context61.prev = _context61.next) {
          case 0:
            return _context61.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum)
            });
          case 1:
          case "end":
            return _context61.stop();
        }
      }, _callee61);
    }));
    function getInterface() {
      return _getInterface26.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var mathwallet = {
  label: ProviderLabel.MathWallet,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref36) {
    var provider = _ref36.provider;
    return !!provider && !!provider[ProviderIdentityFlag.MathWallet];
  },
  getIcon: function () {
    var _getIcon34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
      return _regeneratorRuntime().wrap(function _callee62$(_context62) {
        while (1) switch (_context62.prev = _context62.next) {
          case 0:
            _context62.next = 2;
            return import('./icons/mathwallet.js');
          case 2:
            return _context62.abrupt("return", _context62.sent.default);
          case 3:
          case "end":
            return _context62.stop();
        }
      }, _callee62);
    }));
    function getIcon() {
      return _getIcon34.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.MathWallet),
  platforms: ['all']
};
var gamestop = {
  label: ProviderLabel.GameStop,
  injectedNamespace: InjectedNameSpace.GameStop,
  checkProviderIdentity: function checkProviderIdentity(_ref37) {
    var provider = _ref37.provider;
    return !!provider && !!provider[ProviderIdentityFlag.GameStop];
  },
  getIcon: function () {
    var _getIcon35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
      return _regeneratorRuntime().wrap(function _callee63$(_context63) {
        while (1) switch (_context63.prev = _context63.next) {
          case 0:
            _context63.next = 2;
            return import('./icons/gamestop.js');
          case 2:
            return _context63.abrupt("return", _context63.sent.default);
          case 3:
          case "end":
            return _context63.stop();
        }
      }, _callee63);
    }));
    function getIcon() {
      return _getIcon35.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
      var provider;
      return _regeneratorRuntime().wrap(function _callee64$(_context64) {
        while (1) switch (_context64.prev = _context64.next) {
          case 0:
            provider = createEIP1193Provider(window.gamestop, {
              eth_chainId: function eth_chainId(_ref38) {
                var baseRequest = _ref38.baseRequest;
                return baseRequest({
                  method: 'eth_chainId'
                }).then(function (id) {
                  return "0x".concat(parseInt(id).toString(16));
                });
              },
              wallet_switchEthereumChain: UNSUPPORTED_METHOD
            });
            provider.removeListener = function (event, listener) {};
            provider.on = function (event, listener) {};
            return _context64.abrupt("return", {
              provider: provider
            });
          case 4:
          case "end":
            return _context64.stop();
        }
      }, _callee64);
    }));
    function getInterface() {
      return _getInterface27.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var bitkeep = {
  label: ProviderLabel.BitKeep,
  injectedNamespace: InjectedNameSpace.BitKeep,
  checkProviderIdentity: function checkProviderIdentity(_ref39) {
    var provider = _ref39.provider;
    return !!provider && !!provider['ethereum'][ProviderIdentityFlag.BitKeep];
  },
  getIcon: function () {
    var _getIcon36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
      return _regeneratorRuntime().wrap(function _callee65$(_context65) {
        while (1) switch (_context65.prev = _context65.next) {
          case 0:
            _context65.next = 2;
            return import('./icons/bitkeep.js');
          case 2:
            return _context65.abrupt("return", _context65.sent.default);
          case 3:
          case "end":
            return _context65.stop();
        }
      }, _callee65);
    }));
    function getIcon() {
      return _getIcon36.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
      return _regeneratorRuntime().wrap(function _callee66$(_context66) {
        while (1) switch (_context66.prev = _context66.next) {
          case 0:
            return _context66.abrupt("return", {
              provider: window.bitkeep && window.bitkeep.ethereum
            });
          case 1:
          case "end":
            return _context66.stop();
        }
      }, _callee66);
    }));
    function getInterface() {
      return _getInterface28.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var sequence = {
  label: ProviderLabel.Sequence,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref40) {
    var provider = _ref40.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Sequence];
  },
  getIcon: function () {
    var _getIcon37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
      return _regeneratorRuntime().wrap(function _callee67$(_context67) {
        while (1) switch (_context67.prev = _context67.next) {
          case 0:
            _context67.next = 2;
            return import('./icons/sequence.js');
          case 2:
            return _context67.abrupt("return", _context67.sent.default);
          case 3:
          case "end":
            return _context67.stop();
        }
      }, _callee67);
    }));
    function getIcon() {
      return _getIcon37.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
      return _regeneratorRuntime().wrap(function _callee68$(_context68) {
        while (1) switch (_context68.prev = _context68.next) {
          case 0:
            return _context68.abrupt("return", {
              provider: window.ethereum
            });
          case 1:
          case "end":
            return _context68.stop();
        }
      }, _callee68);
    }));
    function getInterface() {
      return _getInterface29.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var core = {
  label: ProviderLabel.Core,
  injectedNamespace: InjectedNameSpace.Avalanche,
  checkProviderIdentity: function checkProviderIdentity(_ref41) {
    var provider = _ref41.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Core];
  },
  getIcon: function () {
    var _getIcon38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
      return _regeneratorRuntime().wrap(function _callee69$(_context69) {
        while (1) switch (_context69.prev = _context69.next) {
          case 0:
            _context69.next = 2;
            return import('./icons/core.js');
          case 2:
            return _context69.abrupt("return", _context69.sent.default);
          case 3:
          case "end":
            return _context69.stop();
        }
      }, _callee69);
    }));
    function getIcon() {
      return _getIcon38.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.Core),
  // Core wallet is only tested in chrome or chromium browser
  platforms: ['desktop', 'Chrome', 'Chromium', 'Microsoft Edge']
};
var bitski = {
  label: ProviderLabel.Bitski,
  injectedNamespace: InjectedNameSpace.Bitski,
  checkProviderIdentity: function checkProviderIdentity(_ref42) {
    var provider = _ref42.provider;
    return !!provider && !!provider.getProvider && !!provider.getProvider().isBitski;
  },
  getIcon: function () {
    var _getIcon39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
      return _regeneratorRuntime().wrap(function _callee70$(_context70) {
        while (1) switch (_context70.prev = _context70.next) {
          case 0:
            _context70.next = 2;
            return import('./icons/bitski.js');
          case 2:
            return _context70.abrupt("return", _context70.sent.default);
          case 3:
          case "end":
            return _context70.stop();
        }
      }, _callee70);
    }));
    function getIcon() {
      return _getIcon39.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
      return _regeneratorRuntime().wrap(function _callee71$(_context71) {
        while (1) switch (_context71.prev = _context71.next) {
          case 0:
            return _context71.abrupt("return", {
              provider: window.Bitski && window.Bitski.getProvider && window.Bitski.getProvider()
            });
          case 1:
          case "end":
            return _context71.stop();
        }
      }, _callee71);
    }));
    function getInterface() {
      return _getInterface30.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var zerion = {
  label: ProviderLabel.Zerion,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref43) {
    var provider = _ref43.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Zerion];
  },
  getIcon: function () {
    var _getIcon40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
      return _regeneratorRuntime().wrap(function _callee72$(_context72) {
        while (1) switch (_context72.prev = _context72.next) {
          case 0:
            _context72.next = 2;
            return import('./icons/zerion.js');
          case 2:
            return _context72.abrupt("return", _context72.sent.default);
          case 3:
          case "end":
            return _context72.stop();
        }
      }, _callee72);
    }));
    function getIcon() {
      return _getIcon40.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
      return _regeneratorRuntime().wrap(function _callee73$(_context73) {
        while (1) switch (_context73.prev = _context73.next) {
          case 0:
            return _context73.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum)
            });
          case 1:
          case "end":
            return _context73.stop();
        }
      }, _callee73);
    }));
    function getInterface() {
      return _getInterface31.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var enkrypt = {
  label: ProviderLabel.Enkrypt,
  injectedNamespace: InjectedNameSpace.Enkrypt,
  checkProviderIdentity: function checkProviderIdentity(_ref44) {
    var provider = _ref44.provider;
    return !!provider && !!provider.providers && !!provider.providers.ethereum;
  },
  getIcon: function () {
    var _getIcon41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
      return _regeneratorRuntime().wrap(function _callee74$(_context74) {
        while (1) switch (_context74.prev = _context74.next) {
          case 0:
            _context74.next = 2;
            return import('./icons/enkrypt.js');
          case 2:
            return _context74.abrupt("return", _context74.sent.default);
          case 3:
          case "end":
            return _context74.stop();
        }
      }, _callee74);
    }));
    function getIcon() {
      return _getIcon41.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
      var addListener, provider;
      return _regeneratorRuntime().wrap(function _callee75$(_context75) {
        while (1) switch (_context75.prev = _context75.next) {
          case 0:
            addListener = window.enkrypt.providers.ethereum.on.bind(window.enkrypt.providers.ethereum);
            window.enkrypt.providers.ethereum.on = function (event, func) {
              // intercept chainChanged event and format string
              if (event === 'chainChanged') {
                addListener(event, function (chainId) {
                  var cb = func;
                  cb("0x".concat(parseInt(chainId).toString(16)));
                });
              } else {
                addListener(event, func);
              }
            };
            provider = createEIP1193Provider(window.enkrypt.providers.ethereum, {
              eth_chainId: function eth_chainId(_ref45) {
                var baseRequest = _ref45.baseRequest;
                return baseRequest({
                  method: 'eth_chainId'
                }).then(function (id) {
                  return "0x".concat(parseInt(id).toString(16));
                });
              }
            });
            provider.removeListener = function (event, func) {};
            return _context75.abrupt("return", {
              provider: provider
            });
          case 5:
          case "end":
            return _context75.stop();
        }
      }, _callee75);
    }));
    function getInterface() {
      return _getInterface32.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var phantom = {
  label: ProviderLabel.Phantom,
  injectedNamespace: InjectedNameSpace.Phantom,
  checkProviderIdentity: function checkProviderIdentity(_ref46) {
    var provider = _ref46.provider;
    return !!provider && !!provider['ethereum'] && !!provider['ethereum'][ProviderIdentityFlag.Phantom];
  },
  getIcon: function () {
    var _getIcon42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
      return _regeneratorRuntime().wrap(function _callee76$(_context76) {
        while (1) switch (_context76.prev = _context76.next) {
          case 0:
            _context76.next = 2;
            return import('./icons/phantom.js');
          case 2:
            return _context76.abrupt("return", _context76.sent.default);
          case 3:
          case "end":
            return _context76.stop();
        }
      }, _callee76);
    }));
    function getIcon() {
      return _getIcon42.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
      return _regeneratorRuntime().wrap(function _callee77$(_context77) {
        while (1) switch (_context77.prev = _context77.next) {
          case 0:
            return _context77.abrupt("return", {
              provider: createEIP1193Provider(window.phantom.ethereum)
            });
          case 1:
          case "end":
            return _context77.stop();
        }
      }, _callee77);
    }));
    function getInterface() {
      return _getInterface33.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var safepal = {
  label: ProviderLabel.SafePal,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref47) {
    var provider = _ref47.provider;
    return !!provider && !!provider[ProviderIdentityFlag.SafePal];
  },
  getIcon: function () {
    var _getIcon43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
      return _regeneratorRuntime().wrap(function _callee78$(_context78) {
        while (1) switch (_context78.prev = _context78.next) {
          case 0:
            _context78.next = 2;
            return import('./icons/safepal.js');
          case 2:
            return _context78.abrupt("return", _context78.sent.default);
          case 3:
          case "end":
            return _context78.stop();
        }
      }, _callee78);
    }));
    function getIcon() {
      return _getIcon43.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
      return _regeneratorRuntime().wrap(function _callee79$(_context79) {
        while (1) switch (_context79.prev = _context79.next) {
          case 0:
            return _context79.abrupt("return", {
              provider: createEIP1193Provider(window.ethereum)
            });
          case 1:
          case "end":
            return _context79.stop();
        }
      }, _callee79);
    }));
    function getInterface() {
      return _getInterface34.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var rainbow = {
  label: ProviderLabel.Rainbow,
  injectedNamespace: InjectedNameSpace.Ethereum,
  checkProviderIdentity: function checkProviderIdentity(_ref48) {
    var provider = _ref48.provider;
    return !!provider && !!provider[ProviderIdentityFlag.Rainbow];
  },
  getIcon: function () {
    var _getIcon44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
      return _regeneratorRuntime().wrap(function _callee80$(_context80) {
        while (1) switch (_context80.prev = _context80.next) {
          case 0:
            _context80.next = 2;
            return import('./icons/rainbow.js');
          case 2:
            return _context80.abrupt("return", _context80.sent.default);
          case 3:
          case "end":
            return _context80.stop();
        }
      }, _callee80);
    }));
    function getIcon() {
      return _getIcon44.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: getInjectedInterface(ProviderIdentityFlag.Rainbow),
  platforms: ['all']
};
var okxwallet = {
  label: ProviderLabel.OKXWallet,
  injectedNamespace: InjectedNameSpace.OKXWallet,
  checkProviderIdentity: function checkProviderIdentity(_ref49) {
    var provider = _ref49.provider;
    return !!provider && !!provider[ProviderIdentityFlag.OKXWallet];
  },
  getIcon: function () {
    var _getIcon45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
      return _regeneratorRuntime().wrap(function _callee81$(_context81) {
        while (1) switch (_context81.prev = _context81.next) {
          case 0:
            _context81.next = 2;
            return import('./icons/okxwallet.js');
          case 2:
            return _context81.abrupt("return", _context81.sent.default);
          case 3:
          case "end":
            return _context81.stop();
        }
      }, _callee81);
    }));
    function getIcon() {
      return _getIcon45.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
      return _regeneratorRuntime().wrap(function _callee82$(_context82) {
        while (1) switch (_context82.prev = _context82.next) {
          case 0:
            return _context82.abrupt("return", {
              provider: createEIP1193Provider(window.okxwallet)
            });
          case 1:
          case "end":
            return _context82.stop();
        }
      }, _callee82);
    }));
    function getInterface() {
      return _getInterface35.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['desktop']
};
var defiwallet = {
  label: ProviderLabel.DeFiWallet,
  injectedNamespace: InjectedNameSpace.DeFiConnectProvider,
  checkProviderIdentity: function checkProviderIdentity(_ref50) {
    var provider = _ref50.provider;
    return !!provider && !!provider[ProviderIdentityFlag.DeFiWallet];
  },
  getIcon: function () {
    var _getIcon46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
      return _regeneratorRuntime().wrap(function _callee83$(_context83) {
        while (1) switch (_context83.prev = _context83.next) {
          case 0:
            _context83.next = 2;
            return import('./icons/defiwallet.js');
          case 2:
            return _context83.abrupt("return", _context83.sent.default);
          case 3:
          case "end":
            return _context83.stop();
        }
      }, _callee83);
    }));
    function getIcon() {
      return _getIcon46.apply(this, arguments);
    }
    return getIcon;
  }(),
  getInterface: function () {
    var _getInterface36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
      return _regeneratorRuntime().wrap(function _callee84$(_context84) {
        while (1) switch (_context84.prev = _context84.next) {
          case 0:
            return _context84.abrupt("return", {
              provider: createEIP1193Provider(window.deficonnectProvider)
            });
          case 1:
          case "end":
            return _context84.stop();
        }
      }, _callee84);
    }));
    function getInterface() {
      return _getInterface36.apply(this, arguments);
    }
    return getInterface;
  }(),
  platforms: ['all']
};
var wallets = [zeal, exodus, frontier, metamask, bifrostwallet, binance, coinbase, detected, trust, opera, status, alphawallet, apexwallet, atoken, bitpie, blockwallet, brave, frame, huobiwallet, hyperpay, imtoken, liquality, meetone, mykey, ownbit, tokenpocket, tp, xdefi, oneInch, tokenary, tally, rabby, mathwallet, gamestop, bitkeep, sequence, core, bitski, enkrypt, phantom, okxwallet, zerion, rainbow, safepal, defiwallet, infinitywallet];
export default wallets;